import { useEffect, useState } from "react";
import { RefreshCw, X } from "lucide-react";

const CHECK_MS = 5 * 60 * 1000;
const bundleOf = (html) => (html.match(/\/static\/js\/main\.[a-f0-9]+\.js/) || [])[0] || null;
const currentBundle = () => [...document.scripts].map((s) => s.getAttribute("src") || "").find((s) => /\/static\/js\/main\.[a-f0-9]+\.js/.test(s)) || null;

export const UpdateNotice = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const mine = currentBundle();
    if (!mine) return undefined;
    const check = async () => {
      if (document.visibilityState !== "visible") return;
      try {
        const res = await fetch(`/?v=${Date.now()}`, { cache: "no-store" });
        const latest = bundleOf(await res.text());
        if (latest && latest !== mine) setShow(true);
        navigator.serviceWorker?.getRegistration().then((r) => r?.update()).catch(() => {});
      } catch {
        /* offline */
      }
    };
    const id = setInterval(check, CHECK_MS);
    document.addEventListener("visibilitychange", check);
    check();
    return () => {
      clearInterval(id);
      document.removeEventListener("visibilitychange", check);
    };
  }, []);

  if (!show) return null;
  return (
    <div data-testid="update-notice" className="fixed inset-x-3 bottom-3 z-[1000] mx-auto flex max-w-md items-center gap-3 rounded-2xl bg-[#0B192C] px-4 py-3 text-white shadow-2xl ring-1 ring-amber-400/40 animate-in slide-in-from-bottom-4 print:hidden">
      <RefreshCw className="h-5 w-5 shrink-0 text-amber-400" />
      <button data-testid="update-notice-reload" onClick={() => window.location.reload()} className="flex-1 text-left text-sm font-semibold">
        New version available – <span className="text-amber-400 underline underline-offset-2">tap to update</span>
      </button>
      <button data-testid="update-notice-dismiss" onClick={() => setShow(false)} aria-label="Dismiss" className="text-blue-200 hover:text-white">
        <X className="h-4 w-4" />
      </button>
    </div>
  );
};
